import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAnVEf74WsG0dNsr6Np7ILUbc3-DyIW2Wc",
    authDomain: "twitter-clone-23571.firebaseapp.com",
    databaseURL: "https://twitter-clone-23571.firebaseio.com",
    projectId: "twitter-clone-23571",
    storageBucket: "twitter-clone-23571.appspot.com",
    messagingSenderId: "382359465134",
    appId: "1:382359465134:web:993e92a638a9d1c1de513f",
    measurementId: "G-69KN499M2J"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;